<template>
  <div>
    <div @click="showLocationModal = true" class="location-select d-flex align-items-center">
        <div v-if="isDesktop" >
          <div v-if="showCountryIsoName" class="d-flex align-items-center">
            <i class="fa fa-map-marker map-marker" aria-hidden="true"></i>
            <!-- <h6>{{showCountryIsoName && showCountryIsoName.tag_text}} {{ selectedNameDisplay }}</h6> -->
            <h5>{{selectedCountryDisplay}}</h5>
            <div class="mt-1">
              <img class="whiteDropDown" :src="whiteDropDown" width="20" height="20">
            </div>
          </div>
        </div>
        <div v-else>
          <div v-if="showCountryIsoName" class="d-flex align-items-center">
            <div v-if="!exclusiveUser">
              <i class="fa fa-map-marker map-marker map-marker-icon" aria-hidden="true"></i>
            </div>
            <div v-else>
              <i class="fa fa-map-marker map-marker" aria-hidden="true"></i>
            </div>
            <!-- <h6 :class="{'countrylable': !exclusiveUser}">{{showCountryIsoName && showCountryIsoName.tag_text}} {{ selectedNameDisplay }}</h6> -->
            <h5 :class="{'countrylable': !exclusiveUser}">{{selectedCountryDisplay}}</h5>
            <img class="whiteDropDown" v-if="exclusiveUser" :src="whiteDropDown">
            <img class="BlackDropDown" v-else :src="BlackDropDown">
          </div>
        </div>

        <!-- remove for not showing modal on home page so user cannot select other country -->
    </div>
    <transition v-if="showLocationModal" name="modal">
      <div class="location-modal-wrapper">
        <div class="location-modal-content">
          <h4>Choose your location</h4>
          <div class="location-modal-inner">
            <h6>Select Country</h6>
          <select name="countrySelectBox" class="form-control" placeholder="Select Country" v-model="selectedCountryId" @change="selectboxAddress(selectedCountryId)">
              <option value="0" selected>Select Country</option>
              <option v-for="con in countries" :key="con.id" :value="con.id">
                {{ con.name }}
              </option>
            </select>
            <div v-if="addresses.length > 1" class="location-or d-flex justify-content-center">
                <h6>or</h6>
              </div>
            <div v-if="addresses.length>1" class="location-address-wrapper">
              <h6>Select Address</h6>
              <div class="location-address" :key="index" v-for="(addr, index) in addresses.slice(0, -1)">
                <div class="customradio pull-right">
                  <label>
                    <input class="ckbox" type="radio" v-model="selectedAddressIndex" :value="index" @change="selectAddress(addr.country_id, addr.firstname)" />
                    <span></span>
                  </label>
                </div>
                <span class="fbold">{{ addr.firstname }} {{addr.lastname}}  </span>
                <span v-if="addr.address1"><br/>{{ addr.address1 }}</span>
                <span v-if="addr.address2"><br/>{{ addr.address2 }}</span>
                <span v-if="addr.address3"><br/>{{ addr.address3 }}</span>
                <span v-if="addr.city"><br/>
                    {{ addr.city }} <span v-if="!isSelectedCountryUAE"> - {{ addr.postcode}}</span>
                  </span>
                <span v-if="addr.statename"><br/>{{ addr.statename}}, {{ addr.countryname}} </span>
                <span v-if="addr.phone_no"><br/> Mobile: <span class="fbold">{{ addr.phone_no}}</span></span>
              </div>
            </div>
          </div>
          <div class="location-modal-close" @click="showLocationModal = false">
            <i class="fa fa-times-circle" aria-hidden="true"></i>
          </div>
          <div v-if="locationSelectError" class="location-select-error"> Please select Adress or Country</div>
          <div class="save-location-btn d-flex justify-content-center pointer">
            <button @click="saveLocation" type="button" :disabled="locationSelectError" :class="locationSelectError ? 'save-btn-disabled' : ''">
              Save Location
            </button>
          </div>
        </div>
      </div>
    </transition>
    <transition v-if="selectCurrentCountry">
      <div class="location-modal-wrapper current-country-wrapper text-center">
        <div class="location-modal-content">
          <div class="change-location-title">Hello!</div>
          <div class="change-location-title">You are visiting the website from <span>{{getCurrentCountryIp.country_name}}</span>. Would you like to change the location?</div>
          <div class="location-modal-close" @click="selectCurrentCountry = false">
            <i class="fa fa-times-circle" aria-hidden="true"></i>
          </div>
          <div class="save-location-btn pointer">
            <button @click="changeCurrentCountry(getCurrentCountryIp.country_id)" type="button">
              YES! CHANGE THE LOCATION
            </button>
            <button @click="selectCurrentCountry = false" class="current-country-no" type="button">
              No, I don't want to change the location
            </button>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
  import Vue from 'vue'
  import {mapGetters} from 'vuex'
  import whiteDropDown from '../../../images/Checkbox.png'
  import BlackDropDown from '../../../images/Checkbox_black.png'
  import { appMixins } from '../../assets/js/appMixins'

  export default {
    mixins: [appMixins],
    data () {
      return {
        showLocationModal: false,
        selectedCountryId: '0',
        selectedCountryDisplay: 'India',
        selectedCountryIsoName: 'IND',
        selectedNameDisplay: '',
        selectedAddressIndex: null,
        radioSelected: false,
        selectedAddress: {
          name: '',
          country: '',
          countryId: '',
          isoCode: '',
          isoCode2: ''
        },
        locationSelectError: false,
        selectCurrentCountry: false,
        getCurrentCountryIp: {},
        selectionMethod: 'address',
        whiteDropDown,
        BlackDropDown,
        currentCountryId: this.$store.state.selectedCountryAddress.countryId
      }
    },
    created: function () {
      this.getSelectedAddress()
      this.showCurrentCountry()
      this.loadLastSelectedLocation()
    },
    computed: {
      ...mapGetters({countries: 'countries', addresses: 'addresses', authStatus: 'authStatus', bannerPlcaeHolderData: 'bannerPlcaeHolderData', user: 'user', isComboActive: 'isComboActive', getGlobalSettingKeys: 'getGlobalSettingKeys', isExclusive: 'isExclusive', exclusiveUser: 'exclusiveUser', ipAddresses: 'ipAddresses'}),
      showCountryIsoName: function () {
        const enablevalue = this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_COUNTRY_ISO_WEB'.toLowerCase())
        if (enablevalue) {
          return enablevalue
        } else {
          if (enablevalue !== 0) {
            Vue.ls.remove('lastSelectedLocation')
          }
          return false
        }
      },
      enableTssGlobal: function () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          const tssGlobal = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true &&
            bannerData.product_type.toLowerCase() === 'ENABLE_TSS_GLOBAL'.toLowerCase())
          if (tssGlobal) {
            return true
          } else {
            return false
          }
        }
      },
      isSelectedCountryUAE () {
        return this.currentCountryId ? parseInt(this.currentCountryId) === 221 : false
      }
    },
    watch: {
      authStatus: {
        handler: function (newStatus) {
          if (!newStatus) {
            this.$store.commit('CLEAR_ADDRESSES')
          }
        },
        deep: true
      },
      '$store.state.selectedCountryAddress' (newVal, oldVal) {
        this.getSelectedAddress()
        this.selectedCountryId = this.$store.state.selectedCountryAddress.countryId
        // Perform your actions here
      },
      showLocationModal (newVal, oldVal) {
        if (newVal) {
          this.selectboxAddress(this.selectedCountryId)
          const selectedCountry = Vue.ls.get('selectedCountryAddress')
          this.$store.commit('MOENGAGE_EVENT', {
            eventName: 'global_location_clicked',
            payload: {
              currentLocation: selectedCountry.country || 'NA',
              country_id: selectedCountry.countryId || this.selectedCountryId || '99',
              user_id: (this.user && this.user.user_id) || 0,
              platform: 'web'
            }
          })
        }
      }
    },
    methods: {
      saveLocation () {
        if (this.selectedCountryId === '0' && this.selectedAddressIndex === null) {
          this.locationSelectError = true
          return
        } else {
          Vue.ls.set('selectedCountryAddress', this.selectedAddress)
          this.$store.commit('SET_SELECTED_ADDRESS', this.selectedAddress)
          this.$store.commit('SET_USER_INITIATED_CHANGE')
          this.getSelectedAddress()
          this.showLocationModal = false
        }
        this.$store.commit('MOENGAGE_EVENT', {
          eventName: 'global_location_switched',
          payload: {
            currentLocation: this.selectedAddress.country || 'NA',
            country_id: this.selectedAddress.countryId || this.selectedCountryId || '99',
            user_id: (this.user && this.user.user_id) || 0,
            platform: 'web'
          }
        })
        this.saveLastSelectedLocation()
        if (this.$route.query && this.$route.query.filters) {
          this.$router.push(this.$route.path)
        }
        window.location.reload()
      },
      getSelectedAddress () {
        const getSelectedLocation = this.$store.state.selectedCountryAddress
        if (getSelectedLocation) {
          this.selectedCountryDisplay = getSelectedLocation.country
          this.selectedNameDisplay = getSelectedLocation.name
          this.selectedCountryIsoName = getSelectedLocation.isoCode2 === undefined ? 'IN' : getSelectedLocation.isoCode2
        }
      },
      setAddress (countryId, firstName = '') {
        this.locationSelectError = false
        const filterCountry = this.countries.find(obj => obj.id === countryId)
        this.selectedAddress = {
          name: firstName,
          country: filterCountry && filterCountry.name,
          countryId: countryId,
          isoCode: filterCountry && filterCountry.iso_code_3,
          isoCode2: filterCountry && filterCountry.iso_code_2,
          country_code: filterCountry && filterCountry.country_code
        }
      },
      selectAddress (countryId, firstName) {
        this.selectedCountryId = '0'
        this.setAddress(countryId, firstName)
        this.selectionMethod = 'address'
      },
      selectboxAddress (countryId) {
        this.selectedAddressIndex = null
        this.setAddress(countryId)
        this.selectionMethod = 'country'
      },
      showCurrentCountry () {
        // const getCurrentCountry = Vue.ls.get('CurrentCountryChange')
        const getCurrentCountry = false
        if (!getCurrentCountry) {
          if (this.ipAddresses && this.enableTssGlobal) {
            const lastSelectedLocation = Vue.ls.get('lastSelectedLocation')
            if (lastSelectedLocation && this.showCountryIsoName) {
              let currencyData = {
                currencyType: lastSelectedLocation.selectedCountryCode || '',
                currencySymbol: lastSelectedLocation.selectedCountrySymbol === '?' ? '₹' : (lastSelectedLocation.selectedCountrySymbol || '')
              }
              this.$store.commit('SET_CURRENCY', currencyData)
            } else {
              let currencyData = {
                currencyType: this.ipAddresses.currency_code || '',
                currencySymbol: this.ipAddresses.currency_symbol || ''
              }
              this.$store.commit('SET_CURRENCY', currencyData)
            }
          } else {
            let currencyData = {
              currencyType: 'Rs.',
              currencySymbol: '₹'
            }
            this.$store.commit('SET_CURRENCY', currencyData)
          }
          this.getCurrentCountryIp = this.ipAddresses
          if (this.ipAddresses && Object.keys(this.ipAddresses).length > 0) {
            this.$store.commit('MOENGAGE_EVENT', {
              eventName: 'track_user_current_location',
              payload: {
                ip: this.getCurrentCountryIp && this.getCurrentCountryIp.ip ? this.getCurrentCountryIp.ip : 0,
                country_code3: this.getCurrentCountryIp && this.getCurrentCountryIp.country_code3 ? this.getCurrentCountryIp.country_code3 : 'NA',
                country_name: this.getCurrentCountryIp && this.getCurrentCountryIp.country_name ? this.getCurrentCountryIp.country_name : 'NA',
                country_id: this.getCurrentCountryIp && this.getCurrentCountryIp.country_id || '99',
                user_id: (this.user && this.user.user_id) || 0,
                platform: 'web'
              }
            })
          }
          const currentCountryId = parseInt(this.getCurrentCountryIp.country_id)
          const selectCountryId = parseInt(this.$store.state.selectedCountryAddress.countryId)
          if (currentCountryId !== selectCountryId) {
            if (this.selectedCountryId) {
              this.changeCurrentCountry(this.selectedCountryId)
            } else {
              this.changeCurrentCountry(this.getCurrentCountryIp.country_id)
            }
            // this.selectCurrentCountry = true
            Vue.ls.set('CurrentCountryChange', 'true')
          }
        }
      },
      changeCurrentCountry (countryId) {
        const filterCountry = this.countries.find(obj => obj.id === countryId)
        if (filterCountry) {
          this.selectedAddress = {
            country: filterCountry.name,
            countryId: countryId,
            isoCode: filterCountry.iso_code_3,
            isoCode2: filterCountry.iso_code_2,
            country_code: filterCountry.country_code
          }
          Vue.ls.set('selectedCountryAddress', this.selectedAddress)
          this.$store.commit('SET_SELECTED_ADDRESS', this.selectedAddress)
        }
        this.getSelectedAddress()
        this.selectCurrentCountry = false
        const configKeys = this.getGlobalSettingKeys
        if (this.$route.path !== '/maintenance') {
          Promise.all([
            this.$store.dispatch('CHECK_AUTH'),
            this.$store.dispatch('GET_BANNERS_DATA_FROM_MOBILE_CMS'),
            this.$store.dispatch('GET_NAVMENU_DATA'),
            this.$store.dispatch('GET_UNBXD_ELASTIC_SEARCH_TYPE'),
            this.$store.dispatch('GET_HOME_SCREEN_DATA', {isComboActive: this.isComboActive}),
            this.$store.dispatch('GLOBAL_GET_BANNERS_DATA', { countryId, configKeys })
          ])
        }
        // window.location.reload()
      },
      saveLastSelectedLocation () {
        const filterCountry = this.countries.find(obj => obj.id === (this.selectedCountryId && this.selectedCountryId !== '0' ? this.selectedCountryId : this.selectedAddress && this.selectedAddress.countryId))
        Vue.ls.set('lastSelectedLocation', {
          selectionMethod: this.selectionMethod,
          selectedAddressIndex: this.selectedAddressIndex,
          selectedAddress: this.selectedAddress,
          selectedCountryId: this.selectedCountryId,
          selectedCountrySymbol: filterCountry && filterCountry.currency_symbol,
          selectedCountryCode: filterCountry && filterCountry.currency_code
        })
      },
      loadLastSelectedLocation () {
        const lastSelectedLocation = Vue.ls.get('lastSelectedLocation')
        if (lastSelectedLocation) {
          if (lastSelectedLocation.selectionMethod === 'address') {
            this.selectedCountryId = '0'
            this.selectedAddressIndex = lastSelectedLocation.selectedAddressIndex
            this.selectedAddress = lastSelectedLocation.selectedAddress
          } else if (lastSelectedLocation.selectionMethod === 'country') {
            this.selectedAddressIndex = null
            this.selectedCountryId = lastSelectedLocation.selectedCountryId
            this.setAddress(this.selectedCountryId)
          }
        }
      }
    }
  }
</script>

<style scoped>
.location-select {
  cursor: pointer;
}
.location-select i {
  color: #fff;
  margin-right: 5px;
}
.whiteDropDown{
  /* margin: 6px; */
  margin-left: 8px;
  height: 20px;
}
.BlackDropDown{
  /* margin: 6px; */
  margin-left: 8px;
  height: 14px;
}
.map-marker-icon {
  color: #31857B !important;
}
.map-marker {
  font-size: large !important;
}
.countrylable{
  color: #121212 !important;
}
.save-btn-disabled {
  opacity: 0.7;
}
.location-select h6 {
  font-size: 12px;
  color: #fff;
  margin: 0;
}
.location-select h5 {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  margin: 0;
}
.location-modal-wrapper {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  z-index: 999;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 20px;
  transition: opacity .3s ease;
}
.location-modal-content {
  width: 500px;
  background: #fff;
  border-radius: 10px;
  position: relative;
  background: url('../../assets/images/exclusive-modal-bg.png') #fff;
  background-size: cover;
  padding: 20px 0;
  color: #090A0A;
}
.location-modal-inner {
  padding: 0 20px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}
.location-modal-close {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}
.location-modal-close i {
  font-size: 26px;
}
.location-modal-content h4 {
  font-weight: bold;
  margin-bottom: 20px;
  color: #090A0A;
  padding: 0 20px;
}
.location-modal-content select {
  width: 100%;
  height: 40px;
  font-size: 14px;
  border: 1px solid #CDCFD0;
  border-radius: 4px;
  padding: 0 15px;
}
.save-location-btn button {
  background: #E66A51;
  -webkit-box-shadow: 4px 4px 14px 0px rgba(255,255,255,1);
  -moz-box-shadow: 4px 4px 14px 0px rgba(255,255,255,1);
  box-shadow: 4px 4px 14px 0px rgba(0,0,0,0.4);
  border: 1px solid #E66A51;
  font-size: 16px;
  padding: 10px 30px;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
}
.location-modal-content h6 {
  font-weight: bold;
}
.location-address {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px 20px;
  margin-bottom: 15px;
}
.location-or {
  position: relative;
  margin-bottom: 10px;
}
.location-or:before {
  width: 100%;
  display: inline-block;
  content: '';
  border: 1px solid #ccc;
  position: absolute;
  left: 0;
  top: 10px;
}
.location-or h6 {
  font-weight: normal;
  margin: 0;
  position: relative;
  z-index: 9;
  padding: 0 5px;
  background: #fff;
}
.customradio input {
  display: none;
}
.customradio label > input[type="radio"] + *::before {
  content: "";
  cursor: pointer;
  display: inline-block;
  vertical-align: bottom;
  width: 1rem;
  height: 1rem;
  margin-right: 0.3rem;
  border-radius: 50%;
  border-style: solid;
  border-width: 0.1rem;
  border-color: gray;
}
.customradio label > input[type="radio"]:checked + * {
  color: teal;
}
.customradio label > input[type="radio"]:checked + *::before {
  border-color: #117a7a;
  background: #117a7a;
  cursor: pointer;
  background-clip: content-box;
  padding: 1px;
}
.location-select-error {
  padding: 10px 20px 0;
  color: #ec3d25;
}
.current-country-wrapper .location-modal-content {
  padding: 20px 25px;
}
.current-country-wrapper .save-location-btn button {
  min-width: 335px;
  font-weight: bold;
  border-radius: 8px;
}
.current-country-wrapper .save-location-btn .current-country-no {
  background: #fff;
  border: 1px solid #E66A51;
  color: #E66A51;
  margin-top: 15px;
}
.current-country-wrapper .change-location-title {
  font-size: 16px;
}
.current-country-wrapper .change-location-title span {
  font-weight: bold;
}

@media screen and (max-width: 991px) {
  .location-select > div {
    display: flex;
  }
  .location-select h6 {
    font-size: 14px;
    margin-right: 5px;
  }
  .current-country-wrapper .location-modal-content {
    padding: 20px;
  }
  .current-country-wrapper .save-location-btn button {
    min-width: 260px;
    font-size: 14px;
    padding: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// LocationChange.vue?5910192e